(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay/assets/javascripts/utils/format-text.js') >= 0) return;  svs.modules.push('/components/tur/pay/assets/javascripts/utils/format-text.js');
'use strict';

function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function addOwningGrammarApostrophe(name) {
  return name.slice(-1) === 's' ? name : "".concat(name, "s");
}

function joinWithPunctuation(_ref) {
  let _ref2 = _toArray(_ref),
    arr = _arrayLikeToArray(_ref2).slice(0);
  const last = arr.pop();
  return arr.length ? "".concat(arr.join(', '), " och ").concat(last) : last;
}
svs.tur.pay.utils.format_text = {
  addOwningGrammarApostrophe,
  joinWithPunctuation
};

 })(window);